// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsAppManifest = void 0;
// export type AppManifest = Record<string, any>;
/**
 * @deprecated Use `TeamsManifest` or version-specific types like `TeamsManifestV1D21` from `./generated-types` instead.
 * This class-based manifest definition is outdated. The generated types provide accurate schemas for each manifest version.
 */
class TeamsAppManifest {
    $schema = "https://developer.microsoft.com/en-us/json-schemas/teams/v1.15/MicrosoftTeams.schema.json";
    /**
     * The version of the schema this manifest is using.
     */
    manifestVersion = "1.15";
    /**
     * The version of the app. Changes to your manifest should cause a version change. This version string must follow the semver standard (http://semver.org).
     */
    version = "1.0.0";
    /**
     * A unique identifier for this app. This id must be a GUID.
     */
    id = "{{AppId}}";
    /**
     * A unique identifier for this app in reverse domain notation. E.g: com.example.myapp
     */
    packageName = "com.microsoft.teams.extension";
    localizationInfo;
    developer = {
        name: "Teams App, Inc.",
        mpnId: "",
        websiteUrl: "https://localhost:3000",
        privacyUrl: "https://localhost:3000/privacy",
        termsOfUseUrl: "https://localhost:3000/termsofuse",
    };
    name = {
        short: "{{AppName}}",
        full: "This field is not used",
    };
    description = {
        short: "Short description for {{AppName}}.",
        full: "Full description of {{AppName}}.",
    };
    icons = { outline: "outline.png", color: "color.png" };
    /**
     * A color to use in conjunction with the icon. The value must be a valid HTML color code starting with '#', for example `#4464ee`.
     */
    accentColor = "#FFFFFF";
    /**
     * These are tabs users can optionally add to their channels and 1:1 or group chats and require extra configuration before they are added. Configurable tabs are not supported in the personal scope. Currently only one configurable tab per app is supported.
     */
    configurableTabs;
    /**
     * A set of tabs that may be 'pinned' by default, without the user adding them manually. Static tabs declared in personal scope are always pinned to the app's personal experience. Static tabs do not currently support the 'teams' scope.
     */
    staticTabs;
    /**
     * The set of bots for this app. Currently only one bot per app is supported.
     */
    bots;
    /**
     * The set of Office365 connectors for this app. Currently only one connector per app is supported.
     */
    connectors;
    /**
     * Subscription offer associated with this app.
     */
    subscriptionOffer;
    /**
     * Specify the app's Graph connector configuration. If this is present then webApplicationInfo.id must also be specified.
     */
    graphConnector;
    /**
     * The set of compose extensions for this app. Currently only one compose extension per app is supported.
     */
    composeExtensions;
    /**
     * Specifies the permissions the app requests from users.
     */
    permissions = ["identity", "messageTeamMembers"];
    /**
     * Specify the native features on a user's device that your app may request access to.
     */
    devicePermissions;
    /**
     * A list of valid domains from which the tabs expect to load any content. Domain listings can include wildcards, for example `*.example.com`. If your tab configuration or content UI needs to navigate to any other domain besides the one use for tab configuration, that domain must be specified here.
     */
    validDomains = ["localhost:3000"];
    /**
     * Specify your AAD App ID and Graph information to help users seamlessly sign into your AAD app.
     */
    webApplicationInfo;
    /**
     * A value indicating whether or not show loading indicator when app/tab is loading
     */
    showLoadingIndicator;
    /**
     * A property in the app manifest that declares support for all channel features,
     * categorized by tiers.
     */
    supportsChannelFeatures;
    /**
     * A value indicating whether a personal app is rendered without a tab header-bar
     */
    isFullScreen;
    activities;
    /**
     * A list of tenant configured properties for an app
     */
    configurableProperties;
    /**
     * A value indicating whether an app is blocked by default until admin allows it
     */
    defaultBlockUntilAdminAction;
    /**
     * The install scope defined for this app by default. This will be the option displayed on the button when a user tries to add the app
     */
    defaultInstallScope;
    /**
     * When a group install scope is selected, this will define the default capability when the user installs the app
     */
    defaultGroupCapability;
    /**
     * Specify meeting extension definition
     */
    meetingExtensionDefinition;
    /**
     * The url to the page that provides additional app information for the admins
     */
    publisherDocsUrl;
    /**
     * Specify and consolidates authorization related information for the App.
     */
    authorization;
    copilotExtensions;
    copilotAgents;
}
exports.TeamsAppManifest = TeamsAppManifest;
//# sourceMappingURL=manifest.js.map